// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/functions"; 


import { getAnalytics, isSupported } from "firebase/analytics";


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCeoXjOaIJM-sRiQPgMNTLm8w0BsJeaJOc",
  authDomain: "proinsight-admin.firebaseapp.com",
  projectId: "proinsight-admin",
  storageBucket: "proinsight-admin.appspot.com",
  messagingSenderId: "1029628106942",
  appId: "1:1029628106942:web:dbc6f934eca0d9503be6ef",
  measurementId: "G-SCD4624E2E",
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig); // You need to call initializeApp

export const auth = app.auth();
export const db = app.firestore();
export const storage = app.storage();
export const functions = app.functions(); // Initialize Firebase Functions

/** Region must match deployed Gen1 HTTPS functions (see Firebase console). */
const FUNCTIONS_REGION = "us-central1";

/**
 * HTTPS endpoint that proxies Firebase Storage files for PDF generation (see functions/index.js).
 * Deploy `proxyStorageImageForPdf` for this URL to work in production.
 */
export function getStorageProxyUrlForPdf() {
  return `https://${FUNCTIONS_REGION}-${firebaseConfig.projectId}.cloudfunctions.net/proxyStorageImageForPdf`;
}

// Initialize Analytics (only if supported)
export const analytics = isSupported().then((supported) => {
  return supported ? getAnalytics(app) : null;
});

export default app;


